const parseDescriptionValue = value => {
  const startSentence = (value == null ? void 0 : value.length) > 1 ? 'dos seguros' : 'do seguro';
  const descriptions = value.join(', ').replace(/, ([^,]*)$/, ' e $1').toLowerCase();
  return `${startSentence} ${descriptions}`;
};

export default parseDescriptionValue;